import React from 'react';
import { Link } from 'react-router-dom';
import './AuthShell.css';

const AuthShell = ({
    eyebrow,
    title,
    description,
    asideTitle,
    asideDescription,
    children
}) => (
    <main className="auth-shell">
        <div className="auth-orb auth-orb-one" aria-hidden="true" />
        <div className="auth-orb auth-orb-two" aria-hidden="true" />

        <section className="auth-shell-card">
            <aside className="auth-story">
                <Link to="/" className="auth-brand" aria-label="MultyComm home">
                    <img src="/uploads/logo.webp" alt="MultyComm" />
                </Link>

                <div className="auth-story-copy">
                    <span className="auth-kicker">
                        <i className="fas fa-sparkles" aria-hidden="true" />
                        Business, beautifully connected
                    </span>
                    <h2>{asideTitle}</h2>
                    <p>{asideDescription}</p>
                </div>

                <div className="auth-trust-grid" aria-label="Platform benefits">
                    <div>
                        <span className="auth-trust-icon"><i className="fas fa-shield-alt" /></span>
                        <strong>Secure</strong>
                        <small>Protected access</small>
                    </div>
                    <div>
                        <span className="auth-trust-icon"><i className="fas fa-bolt" /></span>
                        <strong>Fast</strong>
                        <small>Built for momentum</small>
                    </div>
                    <div>
                        <span className="auth-trust-icon"><i className="fas fa-headset" /></span>
                        <strong>Connected</strong>
                        <small>One customer view</small>
                    </div>
                </div>
            </aside>

            <section className="auth-form-panel">
                <div className="auth-mobile-brand">
                    <Link to="/" aria-label="MultyComm home">
                        <img src="/uploads/logo.webp" alt="MultyComm" />
                    </Link>
                </div>
                <div className="auth-form-wrap">
                    <span className="auth-form-eyebrow">{eyebrow}</span>
                    <h1>{title}</h1>
                    <p className="auth-form-description">{description}</p>
                    {children}
                </div>
                <p className="auth-security-note">
                    <i className="fas fa-lock" aria-hidden="true" />
                    Your connection is private and secure
                </p>
            </section>
        </section>
    </main>
);

export default AuthShell;
